import { render, staticRenderFns } from "./dropdownAlgolia.vue?vue&type=template&id=47b8b0c2&"
import script from "./dropdownAlgolia.vue?vue&type=script&lang=js&"
export * from "./dropdownAlgolia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports